// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","blue":"#00afef","grey-lighter":"#e9e9e9"};